import React from 'react';
import type { Contact, ValidationErrors } from '../../../types/wizard';

interface ContactFormProps {
  values: Contact;
  onChange: (data: Partial<Contact>) => void;
  errors: ValidationErrors;
}

const ContactForm: React.FC<Readonly<ContactFormProps>> = ({ values, onChange, errors }) => {
  return (
    <>
      <div className="form-group">
        <label htmlFor="contactName">
          Contact Name
        </label>
        <input
          type="text"
          id="contactName"
          value={values.name}
          onChange={(e) => onChange({ name: e.target.value })}
          className={errors.name ? 'error' : ''}
          placeholder="Enter contact name"
        />
        {errors.name && (
          <div className="error-text">{errors.name}</div>
        )}
      </div>

      <div className="form-row">
        <div className="form-group">
          <label htmlFor="contactPhone">Phone</label>
          <input
            type="tel"
            id="contactPhone"
            value={values.phone || ''}
            onChange={(e) => onChange({ phone: e.target.value })}
            placeholder="(123) 456-7890"
          />
        </div>

        <div className="form-group">
          <label htmlFor="contactEmail">Email</label>
          <input
            type="email"
            id="contactEmail"
            value={values.email || ''}
            onChange={(e) => onChange({ email: e.target.value })}
            placeholder="contact@example.com"
          />
        </div>
      </div>

      <div className="form-group">
        <label htmlFor="contactRole">Role</label>
        <input
          type="text"
          id="contactRole"
          value={values.role}
          onChange={(e) => onChange({ role: e.target.value })}
          placeholder="e.g., Primary, Manager, Administrator"
        />
      </div>
    </>
  );
};

export default ContactForm;
